import Request from '../../../../src/core/gd/data/request'
import {RequestFormType} from "../../../app/tools/request-forms2/const/const"
import RequestFormSettings from "../../model2/form/settings/settings";

export default class ApiRequestForm {

    constructor() {}

    static selectRequestForms():Promise<any> {
        return new Request(this, 'GET', 'request-forms?type=2').promise()
    }

    static selectPublicForms():Promise<any> {
        return new Request(this, 'GET', 'request-forms?type=1').promise()
    }

    static create(params:{
        name            : string,                       // "Public form 2"
        description?    : string,                       // "description for the form"
        type            : RequestFormType,              // 1 or 2
        projectId       : ID,                           // "xCXpgR"
        taskTypeId      : ID,                           // "6h9Lee"
        assignToUserId? : ID | null,                    // null
        settings?       : RequestFormSettings           // {}
    }):Promise<any> {
        return new Request(this, 'POST', 'request-forms', params).promise()
    }

    static getForm(id:ID):Promise<any> {
        return new Request(this, 'GET', 'request-forms/{0}'.f(id)).promise()
    }

    static updateForm(id:ID, params: {
        name?           : string,                       // "Public form 2"
        description?    : string,                       // "description for the form"
        projectId?      : ID,                           // "xCXpgR"
        taskTypeId?     : ID,                           // "6h9Lee"
        assignToUserId? : ID,                           // null
        settings?       : RequestFormSettings         // {}
        isDeleted?      : boolean
    }):Promise<any> {
        return new Request(this, 'PUT', 'request-forms/{0}'.f(id), params).promise()
    }

    static reorderForms(params: {
        requestFormIds? : ID[],
        publicFormIds?  : ID[]
    }):Promise<any> {
        return new Request(this, 'PUT', 'request-forms', params).promise()
    }

    // SUBMISSIONS
    static submissions(requestFormId:ID):Promise<any> {
        return new Request(this, 'GET', 'request-forms/{0}/submissions'.f(requestFormId)).promise()
    }



    // OLD REQUESTS
    create(companyId:ID, name:string, access:number, projectId:ID, taskTypeId:ID, assignToUserId:ID) {
        return new Request(this,'POST','company/'+companyId+'/request-forms', {
            name, access, projectId, taskTypeId, assignToUserId
        });
    }

    delete(companyId:ID, requestFormId:ID) {
        return new Request(this,'DELETE','company/'+companyId+'/request-forms/'+requestFormId);
    }

    updateSortPositions(companyId:ID, arrIds:ID[]) {
        return new Request(this,'PUT','company/'+companyId+'/request-forms', {
            requestFormIds: arrIds
        });
    }

    selectAll(companyId:ID) {
        return new Request(this,'GET','company/'+companyId+'/request-forms');
    }

    selectFull(companyId:ID, id:ID) {
        return new Request(this,'GET','company/'+companyId+'/request-forms/'+id);
    }

    updateSettings(companyId:ID,id:ID, name:string, access:number, projectId:ID, taskTypeId:ID, assignToUserId:ID) {
        return new Request(this,'PUT','company/'+companyId+'/request-forms/'+id, {
            name, access, projectId, taskTypeId, assignToUserId
        });
    }

    saveFormSettings(companyId:ID, id:ID, settings:any) {
        return new Request(this,'POST','company/'+companyId+'/request-forms/'+id, {
            settings
        });
    }

}